(function () {
  var section = document.querySelector('.fabric-guide-page.fg');
  if (!section) return;

  var reveals = section.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    reveals.forEach(function (element) { revealObserver.observe(element); });
  } else {
    reveals.forEach(function (element) { element.classList.add('is-visible'); });
  }

  var navLinks = Array.prototype.slice.call(section.querySelectorAll('.guide-nav__link'));
  var guideSections = Array.prototype.slice.call(section.querySelectorAll('[data-section]'));

  function setActive(id) {
    navLinks.forEach(function (link) {
      var active = link.getAttribute('href') === '#' + id;
      link.classList.toggle('is-active', active);
      if (active && window.innerWidth < 990) {
        var list = link.closest('.guide-nav__list');
        if (list) list.scrollTo({ left: link.offsetLeft - 20, behavior: 'smooth' });
      }
    });
  }

  if ('IntersectionObserver' in window) {
    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) setActive(entry.target.id);
      });
    }, { rootMargin: '-25% 0px -65% 0px' });
    guideSections.forEach(function (guideSection) { sectionObserver.observe(guideSection); });
  }

  var faqItems = Array.prototype.slice.call(section.querySelectorAll('.faq-item'));
  faqItems.forEach(function (item) {
    var button = item.querySelector('.faq-q');
    var panel = item.querySelector('.faq-a');

    button.addEventListener('click', function () {
      var open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.style.height = open ? '0px' : panel.scrollHeight + 'px';
    });
  });

  window.addEventListener('resize', function () {
    faqItems.forEach(function (item) {
      var button = item.querySelector('.faq-q');
      var panel = item.querySelector('.faq-a');
      if (button.getAttribute('aria-expanded') === 'true') {
        panel.style.height = panel.scrollHeight + 'px';
      }
    });
  });
})();
